import User from '../model/User';

export default class UserRepository {
    private static users:Array<User> = [];

    public findByFullname(fullname:string) {
        let users = UserRepository.users.filter( (user:User) => {
            return user.$name === fullname
        })
        if (users.length > 0) {
            return users[0];
        }
        return null
    }

    findByFullnameOrCreate(fullname:string) {
        let user = this.findByFullname(fullname);
        if (user === null) {
            user = new User(fullname);
        }
        return user;
    }
}